









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DocumentIcon extends Vue {
  @Prop({ type: Array, default: null })
  public directory!: Array<string>;
  @Prop({ type: String, default: null })
  public round!: string;
  @Prop({ type: String, default: null })
  public paddingTop!: string;
  @Prop({ type: Boolean, default: false })
  public tile!: boolean;
  @Prop({ type: Number, default: 25 })
  public iconSize!: number;
  @Prop({ type: Number, default: 32 })
  public avatarSize!: number;
  @Prop({ type: String, default: '#4384f3' })
  public iconColor!: string;
  @Prop({ type: String, default: '#4384f3' })
  public avatarColor!: string;
}
